import { Component, OnInit } from '@angular/core';
import { E5coreUiDatagridBase } from './e5core-ui-datagrid-base';

@Component({
  selector: 'e5core-ui-datagrid-box',
  templateUrl: './e5core-ui-datagrid-box.component.html',
  styleUrls: ['./e5core-ui-datagrid-box.component.css']
})
export class E5coreUiDatagridBoxComponent extends E5coreUiDatagridBase implements OnInit {

  constructor() { 
    super() ;
  }

  ngOnInit() {
  }

}